<template>
    <b-modal v-model="visibile" title="Nuovo Utente" size="lg" @ok="onConferma" ok-title="Censisci Utente" cancel-title="Annulla">
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Codice Fiscale Operatore *">
                    <b-form-input v-model="form.codiceFiscaleOperatore" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Nome *">
                    <b-form-input v-model="form.nome" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Cognome *">
                    <b-form-input v-model="form.cognome" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Telefono">
                    <b-form-input v-model="form.telefono" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Email">
                    <b-form-input v-model="form.email" type="email" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Sesso">
                    <b-form-select v-model="form.gender" :options="opzioniGender" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Data di Nascita">
                    <date-picker format="DD/MM/YYYY" value-type="date" type="date" v-model="birthDateModel"></date-picker>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="8">
                <b-form-group label="Tipo Operatore *">
                    <b-form-select v-model="tipoOperatoreSelezionato" :options="opzioniTipoOperatore" @change="onCambiaTipoOperatore" />
                </b-form-group>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import AndiamoMixin from "../mixins/AndiamoMixin";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
    components: { DatePicker },
    mixins: [AndiamoMixin],
    data() {
        return {
            visibile: false,
            birthDateModel: null,
            tipoOperatoreSelezionato: null,
            opzioniGender: [
                { value: null, text: "..." },
                { value: "male", text: "Maschio" },
                { value: "female", text: "Femmina" },
            ],
            opzioniTipoOperatore: [
                { value: "1", text: "1 - MMG" },
                { value: "2", text: "2 - PLS" },
                { value: "3", text: "3 - Infermiere" },
                { value: "4", text: "4 - Medico specialista" },
                { value: "5", text: "5 - Medico esperto in cure palliative" },
                { value: "6", text: "6 - Continuità assistenziale" },
                { value: "7", text: "7 - Psicologo" },
                { value: "8", text: "8 - Fisioterapista" },
                { value: "9", text: "9 - Logopedista" },
                { value: "10", text: "10 - OSS" },
                { value: "11", text: "11 - Dietista" },
                { value: "12", text: "12 - Assistente sociale del SSN" },
                { value: "13", text: "13 - Terapista occupazionale" },
                { value: "99", text: "99 - Altro" },
            ],
            form: {
                codiceFiscaleOperatore: "",
                nome: "",
                cognome: "",
                telefono: "",
                email: "",
                gender: null,
                tipoOperatoreCode: "",
                tipoOperatoreDisplay: "",
            },
        };
    },
    methods: {
        apri() {
            this.form = {
                codiceFiscaleOperatore: "",
                nome: "",
                cognome: "",
                telefono: "",
                email: "",
                gender: null,
                tipoOperatoreCode: "",
                tipoOperatoreDisplay: "",
            };
            this.birthDateModel = null;
            this.tipoOperatoreSelezionato = null;
            this.visibile = true;
        },
        onCambiaTipoOperatore(value) {
            let o = this.opzioniTipoOperatore.find((x) => x.value === value);
            this.form.tipoOperatoreCode = value;
            this.form.tipoOperatoreDisplay = o ? o.text.split(" - ")[1] : "";
        },
        onConferma(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!this.form.codiceFiscaleOperatore || !this.form.nome || !this.form.cognome || !this.form.tipoOperatoreCode) {
                this.$bvToast.toast("Codice Fiscale, Nome, Cognome e Tipo Operatore sono obbligatori", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let body = { ...this.form };
            if (this.birthDateModel) {
                body.birthDate = moment(this.birthDateModel).format("YYYY-MM-DD");
            }
            this.andiamoInserisciUtente(body, this.onSalvaSuccess);
        },
        onSalvaSuccess(response) {
            this.andiamoUtenteSuccess(response);
            this.visibile = false;
            this.$emit("creato");
        },
    },
};
</script>

<style scoped></style>
